import { useState } from "react";

import { ResponsiveContainer, PieChart, Pie, Cell } from "recharts";

import {
  Box,
  Grid,
  Typography,
  Tabs,
  Tab,
  Divider,
  useTheme,
} from "@mui/material";

import { useLayoutHelpers } from "@aclymatepackages/themes";

import SlideLayout from "../../layouts/SlideLayout";

import { CNAUGHT_PROJECT_DESCRIPTION } from "../../../helpers/components/projects";

const CNaughtPieChart = ({ category_allocations }) => {
  const { palette } = useTheme();

  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <ResponsiveContainer
      width="100%"
      height={300}
      style={{ position: "relative" }}
    >
      <Box
        style={{ position: "absolute", inset: 0 }}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        {hoveredIndex !== null && (
          <div>
            <Typography variant="h6" align="center" style={{ maxWidth: 150 }}>
              {category_allocations[hoveredIndex].category.name}
            </Typography>
            <Typography
              variant="subtitle2"
              align="center"
              color="textSecondary"
            >
              {Math.round(
                category_allocations[hoveredIndex].allocated_fraction * 100
              )}
              %
            </Typography>
          </div>
        )}
      </Box>
      <PieChart>
        <Pie
          data={category_allocations}
          dataKey="allocated_fraction"
          nameKey={"category.name"}
          outerRadius={100}
          innerRadius={80}
        >
          {category_allocations.map((_, idx) => (
            <Cell
              key={`portfolio-allocation-pie-${idx}`}
              onMouseOver={() => setHoveredIndex(idx)}
              fill={
                hoveredIndex === idx
                  ? palette.secondary.main
                  : palette.primary.main
              }
            />
          ))}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  );
};

const CnaughtPortfolioDetailsSlider = ({
  name,
  description,
  category_allocations,
  onClose,
  ProjectPurchaseFlow,
  purchaseFlowProps,
  customDescription,
}) => {
  const { isMedium } = useLayoutHelpers();

  const [selectedViewIdx, setSelectedViewIdx] = useState(0);

  const views = [
    ...(isMedium && ProjectPurchaseFlow
      ? [
          {
            label: "Purchase Offsets",
            value: "purchase",
            content: (
              <ProjectPurchaseFlow isCNaughtPurchase {...purchaseFlowProps} />
            ),
          },
        ]
      : []),
    {
      label: "Overview",
      value: "overview",
      content: (
        <Grid container direction="column">
          <Grid item>
            <ResponsiveContainer width="100%" height={300}>
              <CNaughtPieChart category_allocations={category_allocations} />
            </ResponsiveContainer>
          </Grid>
          <Grid item>
            <Typography variant="body2">
              {customDescription || description}
            </Typography>
          </Grid>
        </Grid>
      ),
    },
    {
      label: "About CNaught",
      value: "description",
      content: (
        <Typography variant="body2">{CNAUGHT_PROJECT_DESCRIPTION}</Typography>
      ),
    },
  ];

  const onTabClick = (value) => {
    const tabValueIndex = views.findIndex((tab) => tab.value === value);
    return setSelectedViewIdx(tabValueIndex);
  };

  const { value, content } = views[selectedViewIdx] || {};

  return (
    <SlideLayout
      isSlideOpen
      setIsSlideOpen={onClose}
      header={
        <Grid container spacing={2} alignItems="center">
          <Grid item>
            <img
              src="/images/partner-logos/cnaught.svg"
              alt="cnaught logo"
              width="50px"
            />
          </Grid>
          <Grid item>
            <Typography variant="h2">{name}</Typography>
          </Grid>
        </Grid>
      }
      tagInputs={
        <>
          <Tabs
            value={value}
            onChange={(_, value) => onTabClick(value)}
            variant="scrollable"
            scrollButtons="auto"
          >
            {views.map(({ label, value }, idx) => (
              <Tab
                label={label}
                value={value}
                key={`object-details-view-tab-${idx}`}
              />
            ))}
          </Tabs>
          <Divider />
        </>
      }
      content={content}
      leftContent={
        ProjectPurchaseFlow && (
          <ProjectPurchaseFlow isCNaughtPurchase {...purchaseFlowProps} />
        )
      }
    />
  );
};
export default CnaughtPortfolioDetailsSlider;
